import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export function useApiLocationCountry() {
    return useQuery({
        queryKey: ['api', 'location', 'country'],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/location/country`)
        })())
    })
}


export function useApiLocationProvince() {
    return useQuery({
        queryKey: ['api', 'location', 'province'],
        queryFn: () => ((async (data = {}) => {
            return generalRequest.get(`/location/province`)
        })())
    })
}


export function useApiLocationCity(province = null) {
    return useQuery({
        queryKey: ['api', 'location', 'city', province],
        queryFn: () => ((async (province = {}) => {
            return generalRequest.get(`/location/city?province=${province}`)
        })(province))
    })
}

